module.exports = "/images/trumpet.png?76fe87f21b047bc0dd14ead892f24a96";